import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import Icon from "@/components/UI/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlueCheckIcon',
  props: {
    size: { default: 20 },
    active: { type: Boolean, default: true },
    error: { type: Boolean, default: false }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["check-icon", {active: _ctx.active, error: _ctx.error}]),
    style: _normalizeStyle({'--size' : _ctx.size+'px'})
  }, [
    (_ctx.active)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          name: "check",
          size: 10,
          color: "#fff"
        }))
      : _createCommentVNode("", true)
  ], 6))
}
}

})